// extracted by mini-css-extract-plugin
module.exports = {"container":"CommunityBots_container__3hsBq","header":"CommunityBots_header__2rSM7","leftHeader":"CommunityBots_leftHeader__3Sbuz","botIcon":"CommunityBots_botIcon__31K08"};